import uiCore = require("./uicore");

class ErrorLogClass {
    _registeredErrors : any[] = [];

    public registerError(reason: any) : number {
        return this._registeredErrors.push(reason) - 1;
    }

    public getError(index: number) {
        if (index < 0 || index >= this._registeredErrors.length) {
            return null;
        }
        else {
            return this._registeredErrors[index];
        }
    }

    public registerAndGoToErrorPage(reason: any, $state : ng.ui.IStateService): number {
        var index = this.registerError(reason);
        $state.go("app." + ErrorPage.ComponentDescription.StateString, <ErrorPageStateParams> { errorId : index });
        return index;
    }
}

export interface ErrorPageStateParams {
    errorId: number;
}

export var ErrorLog = new ErrorLogClass();

export class ErrorPage implements uiCore.IDirective {

    public reason: any;

    private _locator: uiCore.DependencyLocator;

    public static ComponentDescription: uiCore.IStandardPageDescription = {
        DirectiveId: "coreerrorpage",
        Url: "/error/{errorId:int}",
        HeaderText: "Error",
        StateString: "coreerrorpage",
        Template: require("./errorpage.html"),
        AngularDependencies: [uiCore.StateDependency, uiCore.StateParamsDependency],
    }

    constructor(...args: any[]) {
        this._locator = uiCore.DependencyLocator.Create(ErrorPage, args);
        var state = <ErrorPageStateParams><any>this._locator.getStateParamsDependency();
        if (state) {
            this.reason = ErrorLog.getError(state.errorId);
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/core/errorpage.ts